<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-switch v-model="isChecked" label="Показать кнопку обнуления количества всех позиций" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import * as mutationsNames from '@/store/modules/setting/mutationNames';

export default {
  computed: {
    isChecked: {
      get() {
        if (localStorage.checkedShowButtonZero) {
          let checkedShowButtonZeroValue = null;
          if (localStorage.checkedShowButtonZero === "true")
            checkedShowButtonZeroValue = true;
          else if (localStorage.checkedShowButtonZero === "false")
            checkedShowButtonZeroValue = false;
          return checkedShowButtonZeroValue;
        } else {
          return this.$store.getters.getValueCheckedShowButtonSetZero;
        }
      },
      set(value) {
        localStorage.checkedShowButtonZero = value;
        this.$store.commit(mutationsNames.SET_CHECKED_SHOW_BUTTON_ZERO, value);
      }
    },
  }
}
</script>